

export default {
    vi : {
        header: 'Nhập mã xác thực',
        description: 'Mã xác thực đã được gửi tới email của bạn. Vui lòng kiểm tra email và nhập chính xác mã vào ô dưới.',
        verificationCode: 'Mã xác thực',
        invalidVerificationCode: 'Mã xác thực không hợp lệ',
        button: 'Tiếp tục',
        login: 'Quay lại đăng nhập',
        others: 'Hoặc đăng ký với'
    },
    en: {
        header: 'Enter verification code',
        description: 'Verification code has just been sent to your email. Please check your email and enter correctly into the textfield below.',
        verificationCode: 'Verification code',
        invalidVerificationCode: 'Verification code is invalid',
        button: 'Continue',
        login: 'Back to login',
        others: 'Register with other options'
    }
};


